import React from 'react';
import { Table, DropdownItem, Numbers, EmptyState, Icon } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import LoadingTable from '../../../../../components/loadingTable';
import SortDropdown from '../../../../../components/sortDropdown';
import Style from './sales.module.css';

const SalesTab = ({ events, currency, loadingData, ordering, onChangeSort }) => {
    const { t, i18n } = useTranslation();
    const locale = i18n.language;

    return (
        <>
            <Table useNew className={Style['table_sales_report']}>
                <Table.THead>
                    <Table.Tr isHeader>
                        <th>
                            <SortDropdown
                                name="event_name"
                                label={t('ticket.sales_report.tab_header.events')}
                                ordering={ordering}
                                items={[
                                    <DropdownItem.Icons
                                        key={1}
                                        checked={ordering === 'event_name'}
                                        item={t('ticket.common.ordering.A-Z')}
                                        onClick={() => onChangeSort('event_name')}
                                    />,
                                    <DropdownItem.Icons
                                        key={2}
                                        checked={ordering === '-event_name'}
                                        item={t('ticket.common.ordering.Z-A')}
                                        onClick={() => onChangeSort('-event_name')}
                                    />
                                ]}
                            />
                        </th>
                        <th>{t('ticket.sales_report.tab_header.start_date')}</th>
                        <th>
                            <SortDropdown
                                name="count"
                                label={t('ticket.sales_report.tab_header.sold_ticket')}
                                ordering={ordering}
                                items={[
                                    <DropdownItem.Icons
                                        key={1}
                                        checked={ordering === 'count'}
                                        item={t('ticket.common.ordering.ascending')}
                                        onClick={() => onChangeSort('count')}
                                    />,
                                    <DropdownItem.Icons
                                        key={2}
                                        checked={ordering === '-count'}
                                        item={t('ticket.common.ordering.descending')}
                                        onClick={() => onChangeSort('-count')}
                                    />
                                ]}
                            />
                        </th>
                        <th>
                            <SortDropdown
                                name="count_refund"
                                label={t('ticket.sales_report.tab_header.refund_ticket')}
                                ordering={ordering}
                                items={[
                                    <DropdownItem.Icons
                                        key={1}
                                        checked={ordering === 'count_refund'}
                                        item={t('ticket.common.ordering.ascending')}
                                        onClick={() => onChangeSort('count_refund')}
                                    />,
                                    <DropdownItem.Icons
                                        key={2}
                                        checked={ordering === '-count_refund'}
                                        item={t('ticket.common.ordering.descending')}
                                        onClick={() => onChangeSort('-count_refund')}
                                    />
                                ]}
                            />
                        </th>
                        <th>
                            <SortDropdown
                                label={t('ticket.sales_report.tab_header.turnover')}
                                name="sum"
                                ordering={ordering}
                                items={[
                                    <DropdownItem.Icons key={1} checked={ordering === 'sum'} item={t('ticket.common.ordering.ascending')} onClick={() => onChangeSort('sum')} />,
                                    <DropdownItem.Icons key={2} checked={ordering === '-sum'} item={t('ticket.common.ordering.descending')} onClick={() => onChangeSort('-sum')} />
                                ]}
                            />
                        </th>
                    </Table.Tr>
                </Table.THead>
                <Table.TBody>
                    {!loadingData &&
                        events.map((event, index) => {
                            return (
                                <Table.Tr key={index}>
                                    <Table.Td className={Style['table-td']}>{event.event_name}</Table.Td>
                                    <Table.Td>
                                        {new Date(event.event_start_date).toLocaleDateString([], {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            timeZone: event.event_timzone
                                        })}
                                    </Table.Td>
                                    <Table.Td className={Style['table-td']}>
                                        {event.count} {t('ticket.sales_report.ticket')}
                                    </Table.Td>
                                    <Table.Td className={Style['table-td']}>
                                        {event.count_refund} {t('ticket.sales_report.ticket')}
                                    </Table.Td>
                                    <Table.Td className={Style['table-td']}>
                                        <Numbers value={event.sum} locale={locale} currency={currency} />
                                    </Table.Td>
                                </Table.Tr>
                            );
                        })}
                </Table.TBody>
            </Table>
            <LoadingTable loading={loadingData} />
            {!loadingData && events.length === 0 && (
                <EmptyState icon={<Icon name="list" />} title={t('ticket.sales_report.empty.title')} subtitle={t('ticket.sales_report.empty.subtitle')} />
            )}
        </>
    );
};

export default SalesTab;
